import { render, staticRenderFns } from "./secKill.vue?vue&type=template&id=fc1f5a3a&scoped=true&"
import script from "./secKill.vue?vue&type=script&lang=ts&"
export * from "./secKill.vue?vue&type=script&lang=ts&"
import style0 from "./secKill.vue?vue&type=style&index=0&id=fc1f5a3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1f5a3a",
  null
  
)

export default component.exports